import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { TextBold } from 'UiKit/typography';
import checkIsInFrame from 'Helper/checkIsInFrame';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const SecurityGate = ({ children }) => {
  const isFramed = checkIsInFrame();

  useEffect(() => {
    if (isFramed) {
      try {
        if (window.top.location.hostname !== window.location.hostname) {
          window.top.location = window.location;
        }
      } catch (e) {}
    }

    const setSecurityMetaTags = () => {
      if (!document.querySelector('meta[http-equiv="X-Frame-Options"]')) {
        const xFrameOptions = document.createElement('meta');
        xFrameOptions.httpEquiv = 'X-Frame-Options';
        xFrameOptions.content = 'DENY';
        document.head.appendChild(xFrameOptions);
      }

      if (!document.querySelector('meta[http-equiv="Content-Security-Policy"]')) {
        const csp = document.createElement('meta');
        csp.httpEquiv = 'Content-Security-Policy';
        csp.content = "frame-ancestors 'none'";
        document.head.appendChild(csp);
      }
    };

    setSecurityMetaTags();
  }, [isFramed]);

  return (
    <Condition statement={isFramed} fallback={children}>
      <Box className={styles['security-gate__container']}>
        <TextBold className={styles['security-gate__text']}>
          This page has been blocked for security reasons. Please access the site directly through your browser.
        </TextBold>
      </Box>
    </Condition>
  );
};

export default SecurityGate;
